import { footerGroups } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-300/40 bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-primary-500/40 bg-primary-500/10 text-primary-300">
                <i className="ri-moon-fill text-xl" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-display text-lg font-bold text-foreground-950">午夜影院</span>
                <span className="font-label mt-1 text-[10px] text-foreground-500">MIDNIGHT CINEMA</span>
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-500">
              深夜打开午夜影院，在线观看最新电影，午夜场与无删减版资源集中收录。悬疑、剧情还是经典老片，
              都能快速找到适合深夜氛围的片单，一个人也能安心刷到尽兴。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full border border-background-300/60 px-3 py-1 text-xs text-foreground-500">
                深夜不打烊
              </span>
              <span className="rounded-full border border-background-300/60 px-3 py-1 text-xs text-foreground-500">
                无删减版
              </span>
              <span className="rounded-full border border-background-300/60 px-3 py-1 text-xs text-foreground-500">
                午夜场
              </span>
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.id}>
              <h4 className="font-display text-sm font-bold text-foreground-900">
                <a href="#top" className="cursor-pointer transition-colors hover:text-primary-300">
                  {group.title}
                </a>
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer text-sm text-foreground-500 transition-colors hover:text-primary-300"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/40 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>午夜影院 · 页面仅供影片片单预览与氛围展示，不提供任何真实播放、下载或上传服务。</p>
          <p className="flex items-center gap-2">
            <i className="ri-moon-clear-line" />
            愿你今晚找到一部好片
          </p>
        </div>
      </div>
    </footer>
  );
}